module.exports = __webpack_public_path__ + "img/ic11.6b1dadae.png";